import { render, staticRenderFns } from "./work-card.vue?vue&type=template&id=f299b198&scoped=true"
import script from "./work-card.vue?vue&type=script&lang=js"
export * from "./work-card.vue?vue&type=script&lang=js"
import style0 from "./work-card.vue?vue&type=style&index=0&id=f299b198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f299b198",
  null
  
)

export default component.exports